export class UserApplication {
	id: number;
	userId: string;
	applicationId: string;
	customerTreeId: number;
	visible: boolean;
}
